export default "__VITE_ASSET__C_2k0oDg__"